import React from 'react';
import {makeApiCallPost} from "../../Api/makeApiCall";
import ButtonLoader from "../../utils/components/ButtonLoader";
import {forceLogout} from "../../auth/url";
import {createDagRunConf} from "../../Api/dagRunConf";
import {
    copyAccessTokenToClipboard,
    getUserTypeFromLocalToken,
    navigateToAirflow,
    navigateToApolloStudioExplorer,
    userType
} from "../../auth/accessTokenValidator";
import {toTitleCase} from "./ReactTable/helpers";
import {BreakCacheButton} from "../../utils/localCache/BreakCacheButton";
import apolloStudio from "../../assets/apollo-graphql-icon.svg";
import elliot from "../../assets/elliot.png";
import {faIcons} from "../../utils/iconConstants";
import airflowIcon from '../../assets/airflow-icon.png';

const TitleDropdown = () => {
    const userTypeFromToken = getUserTypeFromLocalToken()
    return <>
        <button aria-label={"hamburger_menu"}
                className={"title-dropdown"}
                data-position="bottom"
                data-alignment="right"
                type="button"
                data-toggle="title-dropdown">
            <i className={faIcons.bars}/>
        </button>
        <div className="dropdown-pane title-dropdown-content left"
             id="title-dropdown"
             data-dropdown={true}
             data-position="bottom"
             data-alignment="right"
             data-allow-overlap="true"
             data-hover-pane="true"
             data-hover="true">
            <div className={"user-type-div"}>{toTitleCase(userTypeFromToken)}</div>
            {(process.env.REACT_APP_ENV === 'uat' && userTypeFromToken !== userType.locatorsUser) &&
                <>
                    <ButtonLoader buttonTitle={<i className={faIcons.sync}/>}
                                  axiosFunction={makeApiCallPost}
                                  buttonClassName={"header-button"}
                                  buttonProps={{
                                      "aria-label": "sync_button",
                                      "data-tooltip": true,
                                      title: "Sync Services and mappings from PROD",
                                      "data-position": "left",
                                      "data-alignment": "center"
                                  }}
                                  url={`${process.env.REACT_APP_EDP_API_BASE_URL}/dagTrigger/`}
                                  postBody={{
                                      dagName: 'refresh_all_configs_and_services_from_prod',
                                      data: createDagRunConf({"exclude_snapshot": false})
                                  }}
                                  buttonHasModal
                                  confirmationsModalClass={'refresh-all-configs-and-services-from-prod-modal'}
                                  modalHeader={`Are you sure you want to Refresh All Configs And Services From PROD`}
                                  modalText={<div data-testid={"sync_button_modal_text"}>
                                      <h6>You are about to trigger <b>refresh_all_configs_and_services_from_prod</b></h6>
                                      <span data-testid={"sync_button_span"}>This will <b>NOT</b> trigger a <b>normalize_product_snapshot</b> dag run.</span>
                                      <br/>
                                      <span>If the current period is different from production it may cause ingestion issues </span>
                                  </div>}
                    >
                    </ButtonLoader>
                    <ButtonLoader buttonTitle={<i className={faIcons.arrowCircleLeft}/>}
                                  axiosFunction={makeApiCallPost}
                                  buttonClassName={"header-button"}
                                  buttonProps={{
                                      "aria-label": "sync_service_button",
                                      "data-tooltip": true,
                                      title: "Sync Services from PROD",
                                      "data-position": "left",
                                      "data-alignment": "center"
                                  }}
                                  url={`${process.env.REACT_APP_EDP_API_BASE_URL}/dagTrigger/`}
                                  postBody={{
                                      dagName: 'refresh_all_configs_and_services_from_prod',
                                      data: createDagRunConf({
                                          "exclude_service_prefixes": "mappings,projection",
                                          "exclude_snapshot": true
                                      })
                                  }}
                                  buttonHasModal
                                  confirmationsModalClass={'refresh-all-configs-and-services-from-prod-modal'}
                                  modalHeader={`Are you sure you want to Refresh All Configs And Services From PROD`}
                                  modalText={<div data-testid={"sync_button_modal_text"}>
                                      <h6>You are about to trigger <b>refresh_all_configs_and_services_from_prod</b></h6>
                                      <span data-testid={"sync_button_span_1"}>This will trigger a <b>normalize_product_snapshot</b> dag run.</span>
                                      <br/>
                                      <span data-testid={"sync_button_span_2"}>This will <b>NOT</b> copy the <b>mappings</b> folder.</span>
                                      <br/>
                                      <span data-testid={"sync_button_span_3"}>This will <b>NOT</b> copy any <b>projection</b> folder.</span>
                                  </div>}
                    >
                    </ButtonLoader>
                </>
            }
            {(process.env.REACT_APP_ENV !== 'prod' && userTypeFromToken !== userType.locatorsUser) &&
                <ButtonLoader buttonTitle={<img alt={'elliot'} src={elliot} height={20} width={20}/>}
                              axiosFunction={makeApiCallPost}
                              buttonClassName={"header-button"}
                              buttonProps={{
                                  "aria-label": "sync_projections_button",
                                  "data-tooltip": true,
                                  title: "Sync PROJECTIONS data from PROD",
                                  "data-position": "left",
                                  "data-alignment": "center"
                              }}
                              url={`${process.env.REACT_APP_EDP_API_BASE_URL}/dagTrigger/`}
                              postBody={{
                                  dagName: 'refresh_all_projections_data_from_prod',
                                  data: createDagRunConf({})
                              }}
                              buttonHasModal
                              confirmationsModalClass={'refresh-all-projections-data-from-prod-modal'}
                              modalHeader={`Are you sure you want to Refresh All Projections data From PROD?`}
                              modalText={<div data-testid={"sync_button_modal_text"}>
                                  <h6>You are about to trigger <b>refresh_all_projections_data_from_prod</b></h6>
                                  <span data-testid={"sync_button_span"}>This will replace <b>ALL</b> projections data for <b>ALL</b> versions in this environment with current projections data from Production.</span>
                                  <br/>
                              </div>}
                >
                </ButtonLoader>
            }
            <button id={"logout-button"} className={"header-button"} onClick={forceLogout} data-tooltip={true}
                    title="Logout"
                    data-position="left" data-alignment="center">
                <i className={faIcons.logOut}/>
            </button>
            <button id={"copy-token-button"} className={"header-button"} onClick={copyAccessTokenToClipboard}
                    data-tooltip={true} title="Copy Token"
                    data-position="left" data-alignment="center">
                <i className={faIcons.copy}/>
            </button>
            <BreakCacheButton />
            <button id={"apollo-studio-button"} className={"header-button"} onClick={navigateToApolloStudioExplorer}
                    data-tooltip={true} title="Apollo Studio"
                    data-position="left" data-alignment="center">
                <img alt={'apollo-studio'}  src={apolloStudio} className={'apollo-icon'}/>
            </button>
            <button id={"apollo-studio-button"} className={"header-button"} onClick={navigateToAirflow}
                    data-tooltip={true} title="Airflow"
                    data-position="left" data-alignment="center">
                <img alt={'airflow'}  src={airflowIcon} className={'airflow-icon'}  height={20} width={20}/>
            </button>
            {(userTypeFromToken === userType.adminUser) &&
                <a href={`/admin`} className={"header-button"} data-tooltip={true} title="Admin" data-position="left"
                   data-alignment="center">
                    <i className={faIcons.admin}/>
                </a>
            }
        </div>
    </>
};

TitleDropdown.propTypes = {};

export default TitleDropdown;
